<app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

<!-- Modal -->
<div class="modal fade" id="applyMembership" tabindex="-1" aria-labelledby="membershipModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="membershipModalLabel">
                    {{
                    membershipStatus !== "Expired"?
                    ("MEMBERSHIP.APPLY_FOR_MEMBERSHIP"|translate)
                    :("MEMBERSHIP.REAPPLY_FOR_MEMBERSHIP"|translate)}}🎉
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeMembershipModal()"></button>
            </div>
            <div class="modal-body">


                <!-- Apply for membership Form -->
                <!-- @if(membershipStatus === 'Rejected' || membershipStatus === 'Applied' ||
                membershipStatus === ''|| membershipStatus === 'None'){ -->

                <div class="card">
                    <div class="card-header">
                        <h5>
                            {{ membershipStatus !== "Expired"
                            ? ("MEMBERSHIP.APPLYFORMEMBERSHIP" | translate)
                            : ("MEMBERSHIP.REAPPLYFORMEMBERSHIP" | translate)
                            }}
                        </h5>

                    </div>
                    <div class="card-body">

                        <form method="post" name="enq" [formGroup]="MembershipForm" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label>{{"MEMBERSHIP.NATIONALFRONTIMAGE" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="file" (change)="onFileSelected($event)" accept="image/*"
                                        class="form-control" name="nationalIdFrontPath" />
                                    <img *ngIf="previewUrl1" [src]="previewUrl1" alt="nationalIdFrontPath" class="mt-2"
                                        width="120" height="120" style="border-radius: 50%;" />
                                </div>

                                <div class="form-group col-md-12">
                                    <label>{{"MEMBERSHIP.NATIONALBACKIMAGE" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="file" (change)="onFileSelected($event)" accept="image/*"
                                        class="form-control" name="nationalIdBackPath" />
                                    <img *ngIf="previewUrl2" [src]="previewUrl2" alt="nationalIdBackPath" class="mt-2"
                                        width="120" height="120" style="border-radius: 50%;" />
                                </div>

                                <div class="form-group col-md-12">
                                    <label>{{"MEMBERSHIP.PASPORTIMAGE" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="file" (change)="onFileSelected($event)" accept="image/*"
                                        class="form-control" name="passportImagePath" />
                                    <img *ngIf="previewUrl3" [src]="previewUrl3" alt="passportImagePath" class="mt-2"
                                        width="120" height="120" style="border-radius: 50%;" />
                                </div>


                                <div class="form-group col-md-12">
                                    <label>{{"MEMBERSHIP.SUPPORT_DOCUMENTS" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="file" (change)="onSupportiveDocumentsSelected($event)" accept="image/*"
                                        multiple class="form-control" name="supportedDocuments" />
                                    <div class="d-flex gap-2 flex-wrap mt-2">
                                        <img *ngFor="let img of previewUrls4" [src]="img?.path ? img.path : img"
                                            width="100" height="100" style="border-radius: 8px;" />
                                    </div>

                                </div>

                                <div class="form-group col-md-6">
                                    <label> {{"MEMBERSHIP.FULLNAMEARABIC" | translate}} <span
                                            class="required">*</span></label>
                                    <input type="text" formControlName="fullArabicName" class="form-control"
                                        name="fullArabicName">
                                </div>
                                <div class="form-group col-md-6">
                                    <label> {{"MEMBERSHIP.FULLNAMEENGLISH" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="text" formControlName="fullEnglishName" class="form-control"
                                        name="fullEnglishName">
                                </div>
                                <div class="form-group col-md-12">
                                    <label>{{"PROFILE.PHONENUMBER" | translate}}<span class="required">*</span></label>
                                    <input type="text" formControlName="phoneNumber" class="form-control phone-number"
                                        name="phoneNumber" placeholder="+20XXXXXXXXXX">
                                    <small class="text-danger"
                                        *ngIf="f['phoneNumber'].touched && f['phoneNumber'].errors?.['invalidPhoneCode']">
                                        {{ "PROFILE.PHONE_VALIDATION" | translate }}
                                    </small>
                                </div>
                                <div class="form-group col-md-12">
                                    <label> {{"MEMBERSHIP.NATIONALIDNUMBER" | translate}} <span
                                            class="required">*</span></label>
                                    <input type="text" formControlName="nationalIdNumber" class="form-control"
                                        name="nationalIdNumber">
                                </div>
                                <div class="form-group col-md-12">
                                    <label> {{"MEMBERSHIP.TRANINGLEVELNAME" | translate}}<span
                                            class="required">*</span></label>
                                    <!-- <input type="number" formControlName="trainingLevelId" class="form-control"
                                                        name="trainingLevelId"> -->

                                    <select formControlName="trainingLevelId" class="form-control fs-5"
                                        name="trainingLevelId" style="height: 40px; background-color: #f0f1f2">
                                        <option value="" disabled selected>
                                            {{"MEMBERSHIP.CHOOSETRANINGLEVELNAME"
                                            | translate}}</option>
                                        <option *ngFor="let traningLevel of traningLevels" [value]="traningLevel.id">{{
                                            traningLevel.name }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label> {{"MEMBERSHIP.PLACEOFWORK" | translate}}<span
                                            class="required">*</span></label>
                                    <input type="text" formControlName="placeOfWork" class="form-control"
                                        name="placeOfWork">
                                </div>

                                <div class="form-group col-md-12">
                                    <label>{{"MEMBERSHIP.COUNTRY" | translate}}<span class="required">*</span></label>

                                    <select formControlName="nationality" class="form-control fs-5"
                                        style="height: 40px; background-color: #f0f1f2">
                                        <option value="" disabled selected>
                                            {{"MEMBERSHIP.CHOOSENATIONALITY"
                                            | translate}}</option>
                                        <option *ngFor="let country of countries" [value]="country.name">{{ country.name
                                            }}</option>
                                    </select>
                                </div>
                                <div class="col-md-12 contact-form-style-2">
                                    <button data-bs-dismiss="modal" type="submit"
                                        class="btn btn-fill-out submit font-weight-bold" name="submit" value="Submit">
                                        {{"PROFILE.SUBMIT" | translate}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- } -->

            </div>
        </div>
    </div>
</div>